import { AvailableLanguages } from '@repo/toolkit/language-types'
import { SortingValue } from '@repo/ui/data-table'

import i18n from '../../../i18n'
import { CountryList } from '../../lib/types/models/country/country-list'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type GetCountriesListParams = {
  locale?: AvailableLanguages
  sort?: SortingValue
}

const getCurrentLocale = (): AvailableLanguages =>
  localStorage.getItem('language') === 'en' || i18n.language === 'en' ? 'en' : 'fr'

const getParams = (params?: GetCountriesListParams) => ({
  locale: getCurrentLocale(),
  sort: 'asc',
  ...params
})

export const getCountriesListQueryKey = (params?: GetCountriesListParams) => [
  'countries-list',
  getParams(params)
]

export function getCountriesList(params?: GetCountriesListParams) {
  return restApiClient
    .url(constructApiUrl(API.countries.getCountriesList.url, null))
    .query(getParams(params))
    .get<CountryList>()
}
